export default __webpack_public_path__ + "static/media/schist_256x256.c6526981.png";